export default {
  snake: {
    accounts_notes: 'Accounts and Notes Receivable',
    automobiles: 'Automobile',
    cash_on_hand: 'Cash On Hands in Banks',
    iras: 'IRA or Other Retirement Acct',
    life_insurances: 'Life Insurance-Cash Surrender Value Only',
    other: 'Other Assets',
    other_properties: 'Other Personal Property',
    real_estate: 'Real Estate',
    savings_accounts: 'Savings Accounts',
    stocks_and_bonds: 'Stocks and Bonds',
  },
  camel: {
    accountsAndNotes: 'Accounts and Notes Receivable',
    automobiles: 'Automobile',
    cashOnHand: 'Cash On Hands in Banks',
    iras: 'IRA or Other Retirement Acct',
    lifeInsurances: 'Life Insurance-Cash Surrender Value Only',
    other: 'Other Assets',
    otherProperties: 'Other Personal Property',
    realEstate: 'Real Estate',
    savings: 'Savings Accounts',
    stocks: 'Stocks and Bonds',
  },
  camelToSnake: {
    accountsAndNotes: 'accounts_notes',
    automobiles: 'automobiles',
    cashOnHand: 'cash_on_hand',
    iras: 'iras',
    lifeInsurances: 'life_insurances',
    other: 'other',
    otherProperties: 'other_properties',
    realEstate: 'real_estate',
    savings: 'savings_accounts',
    stocks: 'stocks_and_bonds',
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/assetTypeMap.js